import classnames from 'classnames';
import React from 'react';
import { THeadline } from '../../components/template';
import TWidgetButtonLink from '../../components/widget-link';
import styles from '../../styles/widgets/repeater.module.scss';
import Card from '../card';
import { TYPE_TO_ROUTE } from './constants';
import EmptyState from './empty-state';

const GridRepeaterBlock = React.memo(props => {
  const {
    title,
    subTitle,
    linkURL,
    linkText,
    items,
    emptyStateText,
    isDisplayBottomLink,
    isDisplayItemSubTitle,
    isDisplayCardSaveButton,
    isDisplayItemExcerpt,
    repeaterKey,
    onCardInView
  } = props;
  const isEmpty = !items.length;

  return (
    <>
      <THeadline subtitle={subTitle} title={title} className={classnames(styles.title, styles.subHeading)} />
      {isEmpty ? (
        <div className={styles.grid}>
          <EmptyState emptyStateText={emptyStateText} />
        </div>
      ) : (
        <div className={classnames(styles.grid, styles['cards-wrapper'])}>
          {items.map(
            ({
              id,
              slug,
              ownKey,
              type,
              image,
              imageUrl,
              title,
              subTitle: subTitleProp,
              excerpt: excerptProp,
              label,
              url
            }) => {
              const subTitle = isDisplayItemSubTitle ? subTitleProp : '';
              const excerpt = isDisplayItemExcerpt ? excerptProp : '';

              return (
                <Card
                  id={id}
                  key={id}
                  type={type}
                  slug={slug}
                  ownKey={ownKey}
                  repeaterKey={repeaterKey}
                  href={`/${TYPE_TO_ROUTE[type]}/${slug}`}
                  image={image || imageUrl}
                  videoUrl={url}
                  title={title}
                  subTitle={subTitle}
                  excerpt={excerpt}
                  label={label}
                  onCardInView={onCardInView}
                  isDisplayCardSaveButton={isDisplayCardSaveButton}
                />
              );
            }
          )}
        </div>
      )}
      {isDisplayBottomLink && <TWidgetButtonLink className={styles.link} linkText={linkText} linkURL={linkURL} />}
    </>
  );
});

GridRepeaterBlock.displayName = 'GridRepeaterBlock';

export default GridRepeaterBlock;
